import React from "react";
import { format, addDays } from "date-fns";

const DisplayInfoNS4 = ({ d }) => {
  const formatDateNaiss = (dateStr) => {
    if (!dateStr || dateStr.length < 8) return "N/A";
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    const parsedDate = new Date(`${year}-${month}-${day}`);
    return format(addDays(parsedDate, 1), "dd/MM/yyyy");
  };

  return (
    <div className="container my-3">
      <h4 className="text-center display-5 mb-3">
        {d?.NOMEL} {d?.PRENOMEL}{" "}
        {d?.DNAISS ? `né(e) le : ${formatDateNaiss(d.DNAISS)}` : ""}
      </h4>

      {d?.Ecole ? (
        <div className="text-center">
          <h5 className="mb-2">Inscrit(e) en : {d.serie_}</h5>
          <div className="h6 text-muted">
            <p className="mb-1">École : {d.LibelleEt}</p>
            <p className="mb-0">Adresse : {d.AdresseEt}</p>
          </div>
        </div>
      ) : (
        <h5 className="text-center font-weight-bold font-italic text-warning mt-3">
          Vous devez voir votre établissement scolaire pour votre inscription
        </h5>
      )}
    </div>
  );
};

export default DisplayInfoNS4;
